import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../components/molecules/Nav';
import Icon from '../../components/atoms/Icon';
import '../Concession/concession.css';
import './retail.css';

// How full the store is, against its max occupancy
const fullnessColor = (pct) => {
  if (pct >= 90) return 'var(--q-bad)';
  if (pct >= 75) return 'var(--q-warn)';
  return 'var(--q-good)';
};

export default function RetailCard({ locationData, data }) {
  const [theme] = useContext(ThemeContext);
  const name = locationData.name;
  const type = data?.type;

  const renderMetric = () => {
    if (type === 'occupancy') {
      const pct = Math.max(0, data.percentage || 0);
      const color = fullnessColor(pct);
      return (
        <>
          <div className="cx-metric-label">
            <span className="cx-status-dot" style={{ backgroundColor: color }} />
            In store now
          </div>
          <div className="cx-card-value">
            {data.current}
            <span className="cx-card-unit">/ {locationData.maxOccupancy}</span>
          </div>
          <div className="rx-card-fill" aria-hidden="true">
            <div className="rx-card-fill-bar" style={{ width: `${Math.min(pct, 100)}%`, backgroundColor: color }} />
          </div>
          <div className="rx-card-sub">
            <span>{pct}% full</span>
            {data.doorCount != null && (
              <span className="rx-card-traffic" title="Traffic">
                <Icon name="person-walking" />
                {Number(data.doorCount).toLocaleString()}
              </span>
            )}
          </div>
        </>
      );
    }

    if (type === 'door count' || type === 'line count') {
      const isLine = type === 'line count';
      return (
        <>
          <div className="cx-metric-label">{isLine ? 'People in queue' : 'Traffic today'}</div>
          <div className="cx-card-value">
            {isLine ? data.lineCount : data.doorCount}
            <span className="cx-card-unit">people</span>
          </div>
        </>
      );
    }

    // No data yet (still loading, or nothing reported)
    return (
      <>
        <div className="cx-metric-label">No data yet</div>
        <div className="cx-card-value rx-card-empty">—</div>
      </>
    );
  };

  return (
    <Link
      to={`../locations/retail/${name.replace(/ /g, '-').toLowerCase()}`}
      state={{
        id: locationData.id,
        currentLocation: locationData,
      }}
      className="cx-card"
    >
      <div className="cx-card-header">
        <img
          src={theme === 'light'
            ? require(`../../clients/${locationData.logoPath}`)
            : require(`../../clients/${locationData.logoPathDark}`)}
          alt={`${name} logo`}
          className="cx-card-logo"
        />
        <h3 className="cx-card-name">{name}</h3>
      </div>

      <div className="cx-card-metric">{renderMetric()}</div>
    </Link>
  );
}
